/** ArgusMind MVP：Mock 登录后写入，退出时清除 */
export const ARGUS_TOKEN_KEY = 'argus_token';
export const ARGUS_USER_KEY = 'argus_user';
/** 首次登录使用初始密码时标记，修改密码成功后清除 */
export const ARGUS_MUST_CHANGE_PASSWORD_KEY = 'argus_must_change_password';
